/**
 * The field set for a note, shared by resolving an inbox item as one and adding or editing
 * one directly (`NotesSection`). One component for the same reason `TaskFields` is: three
 * copies of "title, body, destination" would drift.
 */

import type { Area, Project } from "../api";
import { DestinationPicker } from "./TaskFields";
import { type NoteFieldValues } from "./noteFieldValues";
import { useAutoGrow } from "./useAutoGrow";

export function NoteFields({
  values,
  onChange,
  areas,
  projects,
  autoFocus = false,
}: {
  values: NoteFieldValues;
  onChange: (patch: Partial<NoteFieldValues>) => void;
  areas: Area[];
  projects: Project[];
  autoFocus?: boolean;
}) {
  const body = useAutoGrow(values.body);

  return (
    <>
      <input
        className="input"
        aria-label="Title"
        value={values.title}
        onChange={(e) => onChange({ title: e.target.value })}
        autoFocus={autoFocus}
      />

      <textarea
        ref={body}
        className="input notes"
        aria-label="Note"
        placeholder="Note"
        rows={2}
        value={values.body}
        onChange={(e) => onChange({ body: e.target.value })}
      />

      <DestinationPicker
        value={values.destination}
        areas={areas}
        projects={projects}
        onChange={(destination) => onChange({ destination })}
        allowInbox
      />
    </>
  );
}
